module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('form', [_c('input', {
    staticClass: "d-none",
    attrs: {
      "type": "email",
      "autocomplete": "email"
    },
    domProps: {
      "value": _vm.user.email
    }
  }), _c('form-input', {
    attrs: {
      "type": "password",
      "autocomplete": "current-password",
      "label": _vm.$t("pos.account.password.current-password")
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _c('form-input', {
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "label": _vm.$t("pos.account.password.new-password")
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _c('form-input', {
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "label": _vm.$t("pos.account.password.repeat-new-password")
    },
    model: {
      value: (_vm.confirmNewPassword),
      callback: function($$v) {
        _vm.confirmNewPassword = $$v
      },
      expression: "confirmNewPassword"
    }
  }), (_vm.showMessage) ? [_vm._l((_vm.errorArray), function(error) {
    return _c('b-alert', {
      key: "error",
      attrs: {
        "show": !!_vm.errors,
        "variant": "danger"
      }
    }, [_vm._v(_vm._s(String(error)))])
  }), _c('b-alert', {
    attrs: {
      "show": !_vm.errors,
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.account.password-changed')))])] : _vm._e(), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.account.password.change-password')))])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e1d54ab"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/account/password/Password.vue
// module id = 2041
// module chunks = 1